"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnCompleteRedirect = void 0;
var lodash_1 = __importDefault(require("lodash"));
var react_router_1 = require("react-router");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useOnCompleteRedirect = function (to, options) {
    var navigate = (0, react_router_1.useNavigate)();
    return lodash_1.default.merge({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onCompleted: function (data) {
            if (data)
                navigate(to);
        },
    }, options);
};
exports.useOnCompleteRedirect = useOnCompleteRedirect;
